import { Dialog, IconButton, Slide, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import html2canvas from 'html2canvas';
import React from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';
import { CancelButton } from '../Buttons';
import modalGraficoStyles from './styles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ModalGraficos = ({
  id = 'modal-graficos',
  fullScreen = false,
  open = false,
  onClose = () => {},
  maxWidth,
  paperClass,
  children,
  titulo = 'Indicadores',
  rodape = '',
  nomeArquivo = 'indicadores',
}) => {
  const classes = modalGraficoStyles();

  const handlePrint = () => {
    const graficos = document.querySelectorAll(`#${id} canvas`);

    const imagensGraficos = [];

    for (let i = 0; i < graficos.length; i += 2) {
      imagensGraficos.push(graficos[i].toDataURL());
    }

    const windowWidth = window.innerWidth;

    const graficosWindow = window.open('', 'PRINT', `height=500px,width=${windowWidth}px`);

    graficosWindow.document.write(`<html><head>`);
    graficosWindow.document.write(`<style type="text/css">
      .tamanho-graficos{
        width: 80%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
      }
    </style>`);
    graficosWindow.document.write('</head><body >');
    graficosWindow.document.write(
      `<h2 style="text-align: center; font-family: Muli, Roboto, Helvetica Neue, Arial, sans-serif; font-weight: 600; margin: 0px 0px 46px 0px; color: #233d4d; opacity: 0.84; font-size: 20">${titulo}</h2>`
    );

    /* 1444x400 2 itens por linha */
    if (imagensGraficos.length === 2) {
      graficosWindow.document.write(
        '<div style="width: 100%; display: grid; row-gap:32px; grid-template-columns: auto auto;">'
      );
    } else {
      graficosWindow.document.write(
        '<div style="width: 100%; display: grid; row-gap:32px; grid-template-columns: auto auto auto;">'
      );
    }

    imagensGraficos.forEach((grafico) => {
      graficosWindow.document.write('<div class="tamanho-graficos">');
      graficosWindow.document.write(`<img width="100%" height="100%" src="${grafico}"></img>`);
      graficosWindow.document.write('</div>');
    });

    graficosWindow.document.write('</div>');

    graficosWindow.document.write(
      `<p style="text-align: left; font-family: Muli, Roboto, Helvetica Neue, Arial, sans-serif; font-weight: normal; margin: 16px 0px 0px 16px; color: #233d4d; opacity: 0.84; font-size: 15">${rodape}</p>`
    );

    graficosWindow.document.write('</body></html>');

    graficosWindow.document.close();

    setTimeout(async () => {
      const canvas = await html2canvas(graficosWindow.document.body);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.download = `${nomeArquivo}.jpg`;
      a.href = canvas.toDataURL('image/jpeg');
      a.click();
      graficosWindow.close();
    }, 100);
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      classes={{
        root: classes.SimpleDialogRoot,
        container: clsx(classes.SimpleDialogContainer),
        paper: clsx(classes.SimpleDialogPaper, maxWidth, paperClass),
        paperFullScreen: classes.SimpleDialogPaperFullScreen,
        paperScrollPaper: classes.SimpleDialogPaperScrollPaper,
        paperWidthSm: classes.paperWidthSm,
      }}
      fullWidth
      open={open}
      onClose={onClose}
      aria-labelledby="simple-dialog"
      TransitionComponent={Transition}
    >
      <div id={id} style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ flex: 1, textAlign: 'center' }}>
            <span id={`${id}-title`} className={classes.IndicadoresContas}>
              {titulo}
            </span>
          </div>
          <Tooltip title="Exportar indicadores">
            <IconButton className="hidePrint" style={{ marginTop: -12, marginRight: 8 }} onClick={handlePrint}>
              <FaCloudDownloadAlt size={32} />
            </IconButton>
          </Tooltip>
          <CancelButton type="button" onClick={onClose}>
            Fechar
          </CancelButton>
        </div>
        {children}
        <div style={{ padding: '16px 16px 16px 32px' }}>
          <p className={classes.textFooter}>{rodape}</p>
        </div>
      </div>
    </Dialog>
  );
};

export default ModalGraficos;
